import { EventDispatcher } from '../events';
import * as marietta from '../../..';

export default class MultipleLoader extends EventDispatcher {
  public data: any;

  public textRequests: any;

  public isParallel: boolean;

  private percent: number;

  private loadIndex: number;

  private textRequestsArray: Array<string>;

  constructor() {
    super();

    this.percent = 0;
    this.loadIndex = 0;
    this.textRequests = {};
    this.textRequestsArray = [];
  }

  public addRequestURL(urls: Array<string>): void {
    for (let i: number = 0, ln: number = urls.length; i < ln; i += 1) {
      const url: string = urls[i];
      this.textRequests[url] = url;
      this.textRequestsArray.push(url);
    }
  }

  public load(): void {
    if (this.isParallel) {
      if (this.textRequestsArray.length > 0) {
        for (let i: number = 0, ln: number = this.textRequestsArray.length; i < ln; i += 1) {
          this.loadTextParallel(i);
        }
      }
    } else if (this.textRequestsArray.length > 0) {
      this.loadText();
    }
  }

  // Single ////////////////////////////////////////////////////

  private loadText(): void {
    const url: string = this.textRequestsArray[this.loadIndex];

    const req: marietta.webcad.flash.net.URLRequest = new marietta.webcad.flash.net.URLRequest(url);
    const loader: marietta.webcad.flash.net.URLLoader = new marietta.webcad.flash.net.URLLoader();
    loader.addEventListener(marietta.webcad.flash.events.Event.COMPLETE, (): void => {
      this.completeHandler(url, loader.data);
    });
    loader.load(req);
  }

  private completeHandler(url: string, data: string): void {
    this.textRequests[url] = data;

    this.loadIndex += 1;

    const ln: number = this.textRequestsArray.length;

    this.percent = this.loadIndex / ln;

    if (this.loadIndex >= ln) {
      const evt: marietta.webcad.flash.events.Event = new marietta.webcad.flash.events.Event(marietta.webcad.flash.events.Event.COMPLETE);
      this.dispatchEvent(evt);
    } else {
      this.loadText();
    }
  }

  // Parallel ////////////////////////////////////////////////////

  private loadTextParallel(index: number): void {
    const url: string = this.textRequestsArray[index];

    const req: marietta.webcad.flash.net.URLRequest = new marietta.webcad.flash.net.URLRequest(url);
    const loader: marietta.webcad.flash.net.URLLoader = new marietta.webcad.flash.net.URLLoader();
    loader.addEventListener(marietta.webcad.flash.events.Event.COMPLETE, (): void => {
      this.completeHandlerParallel(url, loader.data);
    });
    loader.load(req);
  }

  private completeHandlerParallel(url: string, data: string): void {
    this.textRequests[url] = data;

    this.loadIndex += 1;

    const ln: number = this.textRequestsArray.length;

    this.percent = this.loadIndex / ln;

    if (this.loadIndex >= ln) {
      const evt: marietta.webcad.flash.events.Event = new marietta.webcad.flash.events.Event(marietta.webcad.flash.events.Event.COMPLETE);
      this.dispatchEvent(evt);
    }
  }
}
